import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    submitApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/epay/signup/:bankGlAccountId`
    },
    submitBulkEpayApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/epay/signup/bulkEPayApplication`
    },
    createLinkForInternationalApplication: {
        method: 'POST',
        url: `${BASE_PATH_API}/epay/signup/international/:bankGlAccountId`
    },
    
    accountEligibility: {
        method: 'GET',
        url: `${BASE_PATH_API}/epay/signup/accountEligibility`
    },

    saveDraftEpayApplication: {
        method: 'PUT',
        url: `${BASE_PATH_API}/epay/signup/draftApplication`
    },
    
    GetApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/epay/signup/merchantApplication/:merchantAccountApplicationId`
    },
    
    UpdatePropertyEnablementSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/epay/signup/:bankGlAccountId/:merchantAccountApplicationId/propertyEnablementSettings`
    },

    retrieveDraftEpayApplication: {
        method: 'GET',
        url: `${BASE_PATH_API}/epay/signup/:bankGlAccountId/draftApplication`
    },

    getCurrentEpaySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId`
    },

    saveConvenienceFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGLAccountId/eft`
    },

    bulkUpdateConvenienceFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/eft`
    },

    saveAdditionalCreditCardFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/:bankGlAccountId/creditCard`
    },

    bulkUpdateAdditionalCreditCardFee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/banking/epay/settings/bulk/creditCard`
    },

    getSubscriptionPlanType: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/subscriptionPlanType`
    },

    getSetupUsageCount: {
        method: 'GET',
        url: `${BASE_PATH_API}/epay/billing/getSetupUsageCount`
    }
};

export function EpaySignupApi() {
    return createActions(actions);
}
